import { v4 as uuid } from 'uuid';
import axios from 'axios';
const DEVICE_UUID_NAME = 'admin-device-uuid';
const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', JSON.stringify(accessToken));
    }
    else {
        localStorage.removeItem('accessToken');
        delete axios.defaults.headers.common.Authorization;
    }
};
export const login = async ({ cpf, recaptcha, loginEndpoint, }) => {
    try {
        const deviceUUID = uuid();
        const payload = { deviceUUID, cpf, recaptcha, userAgent: navigator.userAgent };
        const response = await axios.post(loginEndpoint, payload);
        const { data } = response.data;
        localStorage.setItem(DEVICE_UUID_NAME, JSON.stringify(deviceUUID));
        localStorage.setItem('@payfaceAdmin', JSON.stringify(data.phoneLastFourDigits));
        sessionStorage.setItem('loginIntentionId', JSON.stringify(data.loginIntentionId));
        return data;
    }
    catch (error) {
        if (error?.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        else {
            throw new Error('INVALID_DATA');
        }
    }
};
export const verifyOTP = async ({ otp, otpEndpoint }) => {
    try {
        const deviceUUID = JSON.parse(localStorage.getItem(DEVICE_UUID_NAME));
        const recaptcha = localStorage.getItem('_grecaptcha');
        const loginIntentionId = JSON.parse(sessionStorage.getItem('loginIntentionId'));
        const payload = { deviceUUID, loginIntentionId, recaptcha, otp, userAgent: navigator.userAgent };
        const response = await axios.put(otpEndpoint, payload);
        const { data } = response.data;
        setSession(data.token);
        localStorage.setItem('@admin:user', JSON.stringify(data.profile));
        localStorage.setItem('isAuthenticated', JSON.stringify(true));
        return data;
    }
    catch (error) {
        if (error?.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        else {
            throw new Error('INVALID_DATA');
        }
    }
};
export const verifyPassword = async ({ password, passwordEndpoint, }) => {
    try {
        const deviceUUID = JSON.parse(localStorage.getItem(DEVICE_UUID_NAME));
        const recaptcha = localStorage.getItem('_grecaptcha');
        const loginIntentionId = JSON.parse(sessionStorage.getItem('loginIntentionId'));
        const payload = { deviceUUID, loginIntentionId, recaptcha, userPassword: password };
        const response = await axios.put(passwordEndpoint, payload);
        const { data } = response.data;
        setSession(data.token);
        localStorage.setItem('@admin:user', JSON.stringify(data.profile));
        localStorage.setItem('isAuthenticated', JSON.stringify(true));
        return data;
    }
    catch (error) {
        if (error?.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        else {
            throw new Error('INVALID_DATA');
        }
    }
};
export function logout() {
    setSession(null);
    localStorage.removeItem('@admin:user');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('@payfaceAdmin');
    localStorage.removeItem('user');
    localStorage.removeItem(DEVICE_UUID_NAME);
    sessionStorage.removeItem('loginIntentionId');
}
//# sourceMappingURL=authJwt.js.map